var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0742 2.61279H11.9492V1.55029H10.8867V2.61279H6.63672V1.55029H5.57422V2.61279H3.44922C2.86484 2.61279 2.38672 3.09092 2.38672 3.67529V14.3003C2.38672 14.8847 2.86484 15.3628 3.44922 15.3628H14.0742C14.6586 15.3628 15.1367 14.8847 15.1367 14.3003V3.67529C15.1367 3.09092 14.6586 2.61279 14.0742 2.61279ZM14.0742 14.3003H3.44922V6.86279H14.0742V14.3003ZM14.0742 5.80029H3.44922V3.67529H5.57422V4.73779H6.63672V3.67529H10.8867V4.73779H11.9492V3.67529H14.0742V5.80029Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar2.1bf8b558d728f8323e4d5244ede36c7f.svg";
export { ForwardRef as ReactComponent };